import * as React from 'react';
import { ICommentSchema } from '../../repositories/newbuilding-card/entities/reviews/CommentSchema';
import { CommentPart } from './parts';

export interface IReviewCommentProps {
  isLegacy: boolean;
  comment: ICommentSchema;
}

export const ReviewComment: React.FC<IReviewCommentProps> = ({ isLegacy, comment }) => {
  return (
    <>
      {isLegacy ? (
        <CommentPart message={comment.legacy as string} />
      ) : (
        <>
          <CommentPart title="Плюсы:" message={comment.positive as string} />
          <CommentPart title="Минусы:" message={comment.negative as string} />
        </>
      )}
    </>
  );
};
